import React from 'react';

interface QueuesIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const QueuesIcon: React.FC<QueuesIconProps> = ({ size = 20, ...props }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      height={size}
      width={size}
    >
      <path
        clipRule="evenodd"
        d="M15.116 2.51c.035 0 .07.003.104.008.546.05 1.004.358 1.359.75.388.428.709 1.015.965 1.7.514 1.37.789 3.18.789 5.032 0 1.852-.275 3.662-.789 5.033-.256.684-.577 1.271-.965 1.7-.284.313-.634.572-1.042.69a.736.736 0 0 1-.307.067H4.936c-.616 0-1.128-.329-1.516-.757-.388-.429-.709-1.016-.965-1.7-.515-1.37-.789-3.181-.789-5.033 0-1.852.274-3.662.789-5.033.256-.684.577-1.271.965-1.7.388-.428.9-.756 1.516-.756h10.18Zm-2.082 1.477H4.936c-.056 0-.2.028-.421.271-.22.244-.46.646-.678 1.228-.435 1.16-.694 2.785-.694 4.514 0 1.73.259 3.353.694 4.514m9.197-10.527a6.75 6.75 0 0 0-.453.98c-.514 1.371-.788 3.181-.788 5.033 0 1.852.274 3.662.788 5.033.133.356.284.685.453.98H4.936c-.056 0-.2-.028-.421-.271-.22-.244-.46-.646-.678-1.228m11.226 1.499c.055 0 .2-.028.421-.271.22-.244.46-.646.677-1.227.436-1.162.695-2.786.695-4.515 0-1.729-.26-3.353-.695-4.514-.218-.582-.457-.984-.677-1.228-.22-.243-.366-.27-.421-.27-.056 0-.201.027-.422.27-.22.244-.459.646-.677 1.228-.436 1.16-.695 2.785-.695 4.514s.26 3.353.695 4.515c.218.581.457.983.677 1.227.22.243.366.27.422.27Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
    </svg>
  );
};
